import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>404 - ページが見つかりません</h1>
      <p>お探しのページは存在しないか、移動した可能性があります。</p>
    </div>
  );
};

export default NotFound;